"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const BaseRepository_1 = tslib_1.__importDefault(require("./BaseRepository"));
const Task_1 = tslib_1.__importDefault(require("../models/Task"));
class TaskRepository extends BaseRepository_1.default {
    constructor() {
        super(...arguments);
        this.model = Task_1.default;
        this.fetchManyQuery = () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/tasks/queries/fetchTasks.graphql')));
        this.fetchOneQuery = () => '';
        this.deleteManyMutation = () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/tasks/mutations/deleteTasks.graphql')));
    }
    get totalTime() {
        if (!this.dataset.count())
            return '0 min';
        const total = moment_1.default.duration(0);
        this.dataset.map((task => {
            const spendTime = task.timeEntries.reduce((prev, cur) => {
                let { endTime } = cur;
                if (!endTime)
                    endTime = moment_1.default().toDate();
                return moment_1.default.duration(moment_1.default(endTime).diff(moment_1.default(cur.startTime))).add(prev);
            }, null);
            total.add(moment_1.default.duration(spendTime));
            return task;
        }));
        const hours = total.hours();
        const minutes = total.minutes();
        return (hours > 0 ? hours + ' h ' : '') + minutes + ' min ';
    }
    delete(uuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const deletedTasks = yield this.query(this.deleteManyMutation, {
                uuids,
            });
            this.dataset = this.dataset.filter(t => t.uuid !== deletedTasks.find(taskUuid => taskUuid === t.uuid));
        });
    }
}
exports.default = TaskRepository;
//# sourceMappingURL=TaskRepository.js.map